import { axiosInstance } from "./axiosInstance";

const cleanParams = (params = {}) =>
	Object.fromEntries(
		Object.entries(params).filter(
			([, value]) => value !== undefined && value !== null && value !== ""
		)
	);

export const SurveyAnalyticsService = {
	getAnalytics: async (params = {}) =>
		axiosInstance.get("/api/feature/user-survey/analytics", {
			params: cleanParams(params),
		}),

	getRespondents: async (params = {}) =>
		axiosInstance.get("/api/feature/user-survey/admin/respondents", {
			params: cleanParams(params),
		}),

	// BE param: user_id responden (bukan id row survey)
	getRespondentDetail: async (userId) =>
		axiosInstance.get(`/api/feature/user-survey/admin/respondents/${userId}`),
};
